import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {}

  save(key: string, value: any): void {
    const valueToSave = typeof value === 'object' ? JSON.stringify(value) : value;
    localStorage.setItem(key, valueToSave);
  }

  get(key: string): any {
    const value = localStorage.getItem(key);

    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }
}
